import { FaInstagram, FaYoutube, FaTiktok, FaFacebookF } from 'react-icons/fa';

function SocialsSection({ visible, sectionRef }) {
  return (
    <section className="socials-section" id="socials" ref={sectionRef}>
      <div className="container">
        <div className={`socials-content ${visible ? 'animate-in' : ''}`}>
          <div className="section-label">Stay Connected</div>
          <h2 className="section-title">Follow Me on My Socials</h2>
          <p className="section-subtitle">
            Stay up to date with the latest games, streams, and community updates.
          </p>

          <div className="socials-grid">
            <a
              href="https://www.instagram.com/vaughngto/"
              target="_blank"
              rel="noopener noreferrer"
              className={`social-card ${visible ? 'animate-in delay-1' : ''}`}
            >
              <div className="social-card-icon instagram">
                <FaInstagram />
              </div>
              <div>
                <div className="social-card-label">Instagram</div>
                <div className="social-card-handle">@vaughngto</div>
              </div>
            </a>

            <a
              href="https://www.youtube.com/@VaughnGTO"
              target="_blank"
              rel="noopener noreferrer"
              className={`social-card ${visible ? 'animate-in delay-2' : ''}`}
            >
              <div className="social-card-icon youtube">
                <FaYoutube />
              </div>
              <div>
                <div className="social-card-label">YouTube</div>
                <div className="social-card-handle">@VaughnGTO</div>
              </div>
            </a>

            <a
              href="https://www.tiktok.com/@vaughn_gto"
              target="_blank"
              rel="noopener noreferrer"
              className={`social-card ${visible ? 'animate-in delay-3' : ''}`}
            >
              <div className="social-card-icon tiktok">
                <FaTiktok />
              </div>
              <div>
                <div className="social-card-label">TikTok</div>
                <div className="social-card-handle">@vaughn_gto</div>
              </div>
            </a>

            <a
              href="https://www.facebook.com/vaughn.gto.2025/"
              target="_blank"
              rel="noopener noreferrer"
              className={`social-card ${visible ? 'animate-in delay-4' : ''}`}
            >
              <div className="social-card-icon facebook">
                <FaFacebookF />
              </div>
              <div>
                <div className="social-card-label">Facebook</div>
                <div className="social-card-handle">Vaughn Gto</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialsSection;
